import { render } from "./KeyboardSuggestions.vue?vue&type=template&id=0fd6d236&scoped=true"
import script from "./KeyboardSuggestions.vue?vue&type=script&lang=js"
export * from "./KeyboardSuggestions.vue?vue&type=script&lang=js"

import "./KeyboardSuggestions.vue?vue&type=style&index=0&id=0fd6d236&lang=css"
import "./KeyboardSuggestions.vue?vue&type=style&index=1&id=0fd6d236&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd6d236"]])

export default __exports__